/*
 * KHUSHI COMMERCE DRAWER COORDINATOR v2
 *
 * Coordinates Cart <-> Wishlist using Horizon's public theme-drawer events and
 * close() method. It deliberately does not patch ThemeDrawer.prototype.
 */

const CART_DRAWER_ID = 'cart-drawer';
const WISHLIST_DRAWER_ID = 'khushi-wishlist-drawer';
const COMMERCE_DRAWER_IDS = new Set([CART_DRAWER_ID, WISHLIST_DRAWER_ID]);

let commerceDrawerQueue = Promise.resolve();

function isCommerceDrawer(drawer) {
  return drawer instanceof HTMLElement && drawer.tagName === 'THEME-DRAWER' && COMMERCE_DRAWER_IDS.has(drawer.id);
}

function otherOpenCommerceDrawers(target) {
  return Array.from(document.querySelectorAll('theme-drawer[open]')).filter(
    (drawer) => drawer !== target && isCommerceDrawer(drawer)
  );
}

async function closeCompetingDrawers(target) {
  const others = otherOpenCommerceDrawers(target);
  if (!others.length) return;

  document.documentElement.setAttribute('data-khushi-commerce-drawer-switching', '');

  try {
    await Promise.all(
      others.map((drawer) => {
        if (typeof drawer.close === 'function') return drawer.close();
        drawer.removeAttribute('open');
        return Promise.resolve();
      })
    );

    // Horizon restores focus to the outgoing drawer's initiator when it closes.
    // If the newly opened commerce drawer is still active, return focus into it.
    if (target.hasAttribute('open')) {
      target.querySelector('.theme-drawer__close-button')?.focus({ preventScroll: true });
    }
  } finally {
    document.documentElement.removeAttribute('data-khushi-commerce-drawer-switching');
  }
}

function queueHandoff(target) {
  const task = () => closeCompetingDrawers(target);
  const queued = commerceDrawerQueue.then(task, task);
  commerceDrawerQueue = queued.catch(() => {});
  return queued;
}

document.addEventListener('theme-drawer:open', (event) => {
  const target = event.target;
  if (!isCommerceDrawer(target)) return;
  queueHandoff(target);
});

customElements.whenDefined('theme-drawer').then(() => {
  document.getElementById(CART_DRAWER_ID)?.setAttribute('data-drawer-group', 'commerce');
  document.getElementById(WISHLIST_DRAWER_ID)?.setAttribute('data-drawer-group', 'commerce');
});
